import queryString from 'query-string';
import type { ParsedUrlQuery } from 'querystring';

const argsMapping: Record<string, string> = {
  utm_source: 'c',
  utm_medium: 'channel',
  utm_campaign: 'af_adSet',
  utm_content: 'af_ad',
  gclid: 'af_sub1',
  fbclid: 'af_sub2',
};

export default function getOneLinkParams(query: ParsedUrlQuery): string {
  const params: Record<string, string> = {
    af_js_web: 'true',
    pid: 'welltory.com',
    af_ss_ver: '2',
  };

  for (const field in query) {
    if (query[field]) {
      params[argsMapping[field]] = query[field] as string;
    }
  }

  return queryString.stringify(params); //something like 'af_js_web=true&af_ss_ver=2&pid=welltory.com&c=facebook&af_channel=cpc&af_ad=cooladname&af_adset=ganw2a_web2app&af_sub1=gclid123&af_sub2=IwAR0YEQYT_O7xqBkxY0wbPbh8jEAZZQNMcfWWDHhVaLP32Vfm8j9l6x_BAcA'
}
